export const YM_XXX_UUID = {
  SERVICE: 0x01ff,
  COMMON: {
    MODEL: 0x1a07,
    FIRMWARE: 0x1a01,
  },
  CONTROLLER: {
    HARDWARE: 0x1a02,
    FIRMWARE: 0x1a01,
    MODEL: 0x1a07,
    OUTPUT_NOTIFY: 0x1B00,
  },
  YM_LED: {
    POWER: 0x0201,
    BRIGHTNESS: 0x0202,
    FLASH_ONCE: 0x0203,
  },
  YM_AU: {
    PLAY_AUDIO: 0x0208,
    RECORD_CONTROL: 0x0209,
  },
  YM_PIR: {
    STATUS: 0x0205,
  },
  YM_DLGT: {
    LIGHT: 0x0204,
  },
  YM_BEEP: {
    POWER: 0x0201,
    FREQUENCY: 0x0216,
  },
  YM_RYG: {
    LIGHT: 0x0201,
  },
  YM_K3: {
    STATUS: 0x0205,
  },
  YM_SWUSB: {
    POWER: 0x0201,
    LEVEL: 0x0202,
  },
  YM_TH1: {
    TEMPERATURE: 0x0206,
    HUMIDITY: 0x0207,
  },
  YM_GNSS: {
    SATELLITES: 0x0243,
    BEIDOU_SATELLITES: 0x0244,
    GPS_SATELLITES: 0x0245,
    SPEED: 0x0247,
    ANGLE: 0x0248,
    ACCELERATION: 0x0249,
    TIME: 0x024a,
    POSITION_STATUS: 0x024b,
    ALTITUDE: 0x024c,
    LATITUDE: 0x024d,
    LONGITUDE: 0x024e,
    DISTANCE: 0x0223,
  },
  YM_US: {
    DISTANCE: 0x0223,
  },
  YM_5G: {
    SIGNAL_STRENGTH: 0x0231,
    IMEI: 0x0232,
    OPERATOR: 0x0233,
    ICCID: 0x0234,
    SIM_ID: 0x0235,
    DATA: 0x0236,
    STATE: 0x0237,
    MQTT_CONNECT: 0x0238,
    USER: 0x0239,
    PASSWORD: 0x023a,
    QOS: 0x023b,
    TOPIC: 0x023c,
    CLIENT_ID: 0x023d,
    HOST: 0x023e,
    PORT: 0x023f,
    PUBLISH: 0x0240,
    SUBSCRIBE: 0x0241,
    MQTT_STATE: 0x0242,
  },
} as const;
